/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-underscore-dangle */

interface CanvasAndContext {
    canvas: HTMLCanvasElement | null;
    context: CanvasRenderingContext2D | null;
}

export default class BaseCanvasFactory {
    private _document: any;

    public _canvas: any;

    constructor({ ownerDocument = globalThis.document } = {}) {
        if (this.constructor === BaseCanvasFactory) {
            this._document = ownerDocument;
        }
    }

    create(width: number, height: number) {
        if (width <= 0 || height <= 0) {
            throw new Error('Invalid canvas size');
        }
        const canvas: HTMLCanvasElement = this._createCanvas(width, height);
        return {
            canvas,
            context: canvas.getContext('2d'),
        };
    }

    reset(canvasAndContext: CanvasAndContext, width: number, height: number) {
        if (!canvasAndContext.canvas) {
            throw new Error('Canvas is not specified');
        }
        if (width <= 0 || height <= 0) {
            throw new Error('Invalid canvas size');
        }
        canvasAndContext.canvas.width = width;
        canvasAndContext.canvas.height = height;
    }

    destroy(canvasAndContext: CanvasAndContext) {
        if (!canvasAndContext.canvas) {
            throw new Error('Canvas is not specified');
        }
        // Zeroing the width and height cause Firefox to release graphics
        // resources immediately, which can greatly reduce memory consumption.
        canvasAndContext.canvas.width = 0;
        canvasAndContext.canvas.height = 0;
        canvasAndContext.canvas = null;
        canvasAndContext.context = null;
    }

    /**
     * @ignore
     */
    _createCanvas(width: number, height: number) {
        const canvas = this._document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        this._canvas = canvas;
        return canvas;
    }
}
